/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { QuotationLineModelODataResultCollection } from "../models";
/**
 * QuotationLineApi - axios parameter creator
 * @export
 */
export const QuotationLineApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationLineDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiQuotationLineDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/QuotationLine/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationLineGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/QuotationLine`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuotationLineApi - functional programming interface
 * @export
 */
export const QuotationLineApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    QuotationLineApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationLineDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationLineModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationLineDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationLineGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationLineModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationLineGet(
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * QuotationLineApi - factory interface
 * @export
 */
export const QuotationLineApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = QuotationLineApiFp(configuration);
  return {
    /**
     *
     * @param {QuotationLineApiApiQuotationLineDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationLineDRAFTGet(
      requestParameters: QuotationLineApiApiQuotationLineDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationLineModelODataResultCollection> {
      return localVarFp
        .apiQuotationLineDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationLineApiApiQuotationLineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationLineGet(
      requestParameters: QuotationLineApiApiQuotationLineGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationLineModelODataResultCollection> {
      return localVarFp
        .apiQuotationLineGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiQuotationLineDRAFTGet operation in QuotationLineApi.
 * @export
 * @interface QuotationLineApiApiQuotationLineDRAFTGetRequest
 */
export interface QuotationLineApiApiQuotationLineDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineDRAFTGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiQuotationLineGet operation in QuotationLineApi.
 * @export
 * @interface QuotationLineApiApiQuotationLineGetRequest
 */
export interface QuotationLineApiApiQuotationLineGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof QuotationLineApiApiQuotationLineGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationLineApiApiQuotationLineGet
   */
  readonly $orderby?: string;
}

/**
 * QuotationLineApi - object-oriented interface
 * @export
 * @class QuotationLineApi
 * @extends {BaseAPI}
 */
export class QuotationLineApi extends BaseAPI {
  /**
   *
   * @param {QuotationLineApiApiQuotationLineDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationLineApi
   */
  public apiQuotationLineDRAFTGet(
    requestParameters: QuotationLineApiApiQuotationLineDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationLineApiFp(this.configuration)
      .apiQuotationLineDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationLineApiApiQuotationLineGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationLineApi
   */
  public apiQuotationLineGet(
    requestParameters: QuotationLineApiApiQuotationLineGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationLineApiFp(this.configuration)
      .apiQuotationLineGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
